import { useDeclineInviteMutation, useAcceptInviteMutation } from '@http';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/ui/Modal';
import { useLobbyStore } from '@stores';

export function InvitedModal() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Lobby.PlayerInvited' });
  const { mutateAsync: declineAsync } = useDeclineInviteMutation();
  const { mutateAsync: acceptAsync } = useAcceptInviteMutation();
  const { setInvitedState, invitedState } = useLobbyStore();

  const close = () => {
    if (!invitedState) return;

    declineAsync({ id: invitedState.id });
    setInvitedState(null);
  };

  const accept = () => {
    if (!invitedState) return;

    acceptAsync({ id: invitedState.id });
    setInvitedState(null);
  };

  return (
    <Modal isOpen={!!invitedState} onRequestClose={close} title={t('title')}>
      <p className="text-center p-2 mt-2">{t('message', { username: invitedState?.username })}</p>
      <div className="flex justify-center mt-4">
        <Button className="border-l-0 border-b-0" onClick={close}>{t('decline')}</Button>
        <Button className="border-x-0 border-b-0" onClick={accept}>{t('accept')}</Button>
      </div>
    </Modal>
  );
}